import React, { useState, useEffect } from "react";
import { Icon, Image, Divider, Header } from 'semantic-ui-react'
import image1 from "../../../assets/locations/papua-new-guinea.jpg"
const Point18 = () => {
    return (
    <React.Fragment>
      <p>
      Докази који потврђују Миланковићеву теорију прецизног временског одређивања појаве ледених доба најпре су дошли са фосилних коралних гребена који су се током топлих међуледених периода формирали на плитком океанском прагу у јужном Пацифику. За време леденог доба, све више воде се повлачи у ледене поларне калоте, ниво океана опада, и гребен израња из воде. Када се лед топи, океан се греје и подиже, и тада се ствара још један гребен. Данас, ти гребени образују видљиви степенасти низ дуж обале Папуе Нове Гвинеје. Ови гребени, чија је старост поуздано утврђена мерењем распада урана у коралима,  бројали су миленијуме између ледених доба. Такође су и одредили максимално трајање сваког од ледених доба. Ти интервали су се на временској скали нашли управо на местима које им је Миланковић одредио.
      </p>
      <Divider horizontal>
        <Header as="h4">
        <Icon name='image' />
        Фотографијa
        </Header>      
      </Divider>
      <Image src={image1} alt="Папуа Нова Гвинеја" fluid />
      

    </React.Fragment>
    )
  }

  export default Point18;

